import * as _ from "lodash";
import { ClientRepo as clientRepo } from "./../clients/client.repo";
import { ReportingService as reportingService } from "../common/reporting.service";
import * as moment from "moment";
import { ReportingParams } from "../reporting/reportingParams";
import { IS_RECONCILED_FLAG } from "../reporting/constants";

class PorfolioAdminController implements angular.IOnInit {
  private client: any;
  public clientPortfolios: Array<any>;
  public selectedClientPortfolios: Array<number>;
  public tempSelectedClientPortfolios: Array<number>;
  public sources: Array<string>;
  public oldestPVDate: Date;
  public oldestTradeDate: any;
  public oldestCashDate: any;
  public crmLink: any;
  public showOptions = true;

  public currencyList: Array<string>;
  public selectedCurrency: string;

  public isLoading: boolean = false;
  public isReconciled: boolean;
  public selectedLocality;
  public localityList;

  public clients;
  public selectedClient;
  public clientNumber;
  public searchText;

  //feature flag
  public showAttribution: boolean = false;

  public isBenchmarkAttributionEnabled = false;

  /** @ngInject */
  constructor(
    private clientRepo: clientRepo,
    private $stateParams: angular.ui.IStateParamsService,
    private reportingService: reportingService,
    private notifyjs,
    private $state: angular.ui.IStateService,
    private healthService: any
  ) {}

  $onInit() {
    this.currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
    this.localityList = [
      { name: "Combined", value: "" },
      { name: "Mauritius", value: "Local" },
      { name: "International", value: "International" },
    ];
    this.selectedCurrency = "MUR";
    this.selectedLocality = "";
    this.clientNumber = this.$stateParams["clientNumber"];
    this.isReconciled = sessionStorage.getItem(IS_RECONCILED_FLAG) === "true";
    this.getClientDetails(this.clientNumber);
    this.getClients();
    this.healthService.getHealthConfig().then((res) => {
      this.showAttribution = res.data.featureToggle.showAttribution === "UAT";
    });
  }

  public enableOptions() {
    this.showOptions = true;
  }

  public disableOptions() {
    this.showOptions = false;
  }

  public getSelectedText() {
    if (
      this.tempSelectedClientPortfolios.length == this.clientPortfolios.length
    )
      return "All Client Portfolios Displayed";

    return `${this.tempSelectedClientPortfolios.length} of ${this.clientPortfolios.length} Portfolios Displayed`;
  }

  public onSelectClose() {
    this.selectedClientPortfolios = this.tempSelectedClientPortfolios;
  }

  public getSourceFileDate(source: string, fileType: string) {
    for (var p of this.client.portfolios) {
      for (var a of p.accounts) {
        // Get the source PV date:
        if (a.source == source) {
          if (fileType == "PV") {
            if (a.latestPVFileDate != null) return new Date(a.latestPVFileDate);
          }
        }
      }
    }
  }

  public getCrmLink() {
    if (this.client.crM_ContactId) {
      this.crmLink = `https://confident.api.crm4.dynamics.com/main.aspx?etc=2&id=${this.client.crM_ContactId}&newWindow=true&pagetype=entityrecord`;
    } else {
      this.crmLink = `https://confident.api.crm4.dynamics.com/main.aspx?etc=1&id=${this.client.crM_AccountId}&newWindow=true&pagetype=entityrecord`;
    }
  }

  public generateReport() {
    this.isLoading = true;
    let yesterday = moment().add(-1, "days").format("YYYY-MM-DD");
    const reportingParams = new ReportingParams();
    reportingParams.reportType = "portfoliosummary";
    reportingParams.currency = this.selectedCurrency;
    reportingParams.fromDate = null;
    reportingParams.toDate = yesterday;
    reportingParams.portfolioIds = this.selectedClientPortfolios;
    reportingParams.displayLocalPerformance = true;
    reportingParams.displayInternationalPerformance = true;
    reportingParams.displayMonthlyPerformance = false;
    reportingParams.displayLineItems = true;
    reportingParams.isReconciled = this.isReconciled;
    this.reportingService
      .generateReport(reportingParams)
      .then((res) => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
        this.notifyjs(
          "The report could not be generated. Please try again later or contact the System Administrator for assistance.",
          "error"
        );
      });
  }

  getClients = () => {
    this.clientRepo
      .getClients(null, null, null, null, "name", "asc", true, null, null, true)
      .then((res) => {
        let data = res.data as any;
        this.clients = data.results as Array<any>;
        if (!this.selectedClient) {
          this.selectedClient = _.first(
            this.clients.filter((c) => c.clientNumber == this.clientNumber)
          );
          let index = _.findIndex(
            this.clients,
            (c: any) => c.clientNumber == this.clientNumber
          );
          if (index > -1) {
            this.clients.splice(index, 1); //, this.clients.splice(index, 1)[0]);
            this.clients.unshift(this.selectedClient);
          }
        }
      })
      .catch((err) => {
        this.notifyjs("Failed to load client details");
      });
  };

  getClientDetails = (clientNumber) => {
    this.clientRepo.getClient(clientNumber, true).then((val) => {
      this.client = val.data;
      this.clientPortfolios = _.map(
        val.data["portfolios"],
        (portfolio: any) => {
          return {
            id: Number(portfolio.portfolioId),
            name: portfolio.name,
            isManaged: portfolio.isManaged,
            source: _.orderBy(
              _.keys(
                _.groupBy(portfolio.accounts, (a: any) => {
                  return a.source;
                })
              ),
              (source) => {
                return source;
              }
            ).join(","),
            accounts: portfolio.accounts,
          };
        }
      );
      this.getCrmLink();
      this.tempSelectedClientPortfolios = _.map(
        val.data["portfolios"],
        (portfolio: any) => {
          return Number(portfolio.portfolioId);
        }
      );
      this.selectedClientPortfolios = this.tempSelectedClientPortfolios;
      this.sources = _.orderBy(
        _.keys(
          _.groupBy(this.clientPortfolios, (p) => {
            return p.source;
          })
        ),
        (source) => {
          return source;
        }
      );
      this.evaluateIfBenchmarkTabIsEnabled(this.client);
    });
  };

  getNewClientDetails = () => {
    let clientNumber = this.selectedClient.clientNumber;
    this.$state.go("root.portfolioManagement.clients.portfolio", {
      clientNumber,
    });
  };

  public evaluateIfBenchmarkTabIsEnabled(client: any) {
    this.isBenchmarkAttributionEnabled =
      client.primaryBenchmarkColumnName !== "Return Target (%)";
  }
}

export const portfolioadmin: angular.IComponentOptions = {
  template: require("./portfolioadmin.html"),
  controller: PorfolioAdminController,
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/portfolioadmin.ts